export default "__VITE_ASSET__QY7cka_l__"